import {
  NgModule,
  NO_ERRORS_SCHEMA,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { UISharedModule } from '@moduurnv2/features';
import { OrganizationLocationsDesktopComponent } from './components/organization-locations-desktop/organization-locations-desktop.component';
import { OrganizationLocationsComponent } from './components/organization-locations.component';
import { LocationComponent } from './components/location/location.component';
import { NgxsModule } from '@ngxs/store';
import {
  LocationState,
  CartState,
  LocationDefaultState,
  AddressState,
  PaymentMethodState,
  OrderState,
  MenuListState,
  GiftLoyaltyMethodState,
  AuthState,
  AnalyticsState
} from '@moduurnv2/libs-orderingapp/src/core';
import { LocationInfoComponent } from './components/location-info/location-info.component';
import { SharedModule } from '../shared/shared.module';
import { OrganizationLocationsWrapperComponent } from './organization-locations-wrapper/organization-locations-wrapper.component';
import { LocationOperatingHoursComponent } from './components/location-operating-hours/location-operating-hours.component';
import { yepdeskEventsModule } from '../yepdesk-events/yepdesk-events.module'
export const routes: Routes = [
  {
    path: '',
    component: OrganizationLocationsWrapperComponent,
  },
];

@NgModule({
  imports: [
    UISharedModule,
    CommonModule,
    RouterModule.forChild(routes),
    NgxsModule.forFeature([
      LocationState,
      CartState,
      LocationDefaultState,
      AddressState,
      PaymentMethodState,
      OrderState,GiftLoyaltyMethodState,AuthState,
      MenuListState,
      AnalyticsState
    ]),
    SharedModule,
    yepdeskEventsModule
  ],
  declarations: [
    OrganizationLocationsComponent,
    LocationComponent,
    LocationInfoComponent,
    OrganizationLocationsWrapperComponent,
    OrganizationLocationsDesktopComponent,
    LocationOperatingHoursComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class OrganizationLocationsModule {}
